import { forwardRef } from "react";
import { Loader2 } from "lucide-react";

const AVATAR = "/jerry.png";

const Bubble = ({ m, i }) => (
    <div
        className={`flex items-end gap-2 ${m.role === "user" ? "justify-end" : "justify-start"}`}
    >
        {m.role === "assistant" && (
            <img
                src={AVATAR}
                alt="Jerry"
                className="h-7 w-7 rounded-full object-cover shrink-0 ring-1 ring-[#E5DFD3]"
            />
        )}
        <div
            className={`max-w-[78%] px-3.5 py-2.5 rounded-2xl text-[14px] leading-relaxed ${
                m.role === "user"
                    ? "bg-[#0E2A47] text-white rounded-br-md"
                    : "bg-white text-[#1A2230] border border-[#E5DFD3] rounded-bl-md"
            }`}
            data-testid={`chat-msg-${m.role}-${i}`}
        >
            {m.content}
        </div>
    </div>
);

const TypingIndicator = () => (
    <div className="flex items-end gap-2 justify-start" data-testid="chatbot-loading">
        <img
            src={AVATAR}
            alt="Jerry"
            className="h-7 w-7 rounded-full object-cover shrink-0 ring-1 ring-[#E5DFD3]"
        />
        <div className="bg-white border border-[#E5DFD3] rounded-2xl rounded-bl-md px-3.5 py-2.5 flex items-center gap-2 text-[13px] text-[#6F6B63]">
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
            Jerry is typing…
        </div>
    </div>
);

const MessageList = forwardRef(function MessageList({ messages, loading }, ref) {
    return (
        <div
            ref={ref}
            className="flex-1 overflow-y-auto chat-scroll px-5 py-4 space-y-3 bg-[#F7F5F0]"
            data-testid="chatbot-messages"
        >
            {messages.map((m, i) => (
                <Bubble key={m.id || `msg-${i}`} m={m} i={i} />
            ))}
            {loading && <TypingIndicator />}
        </div>
    );
});

export default MessageList;
